import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import type { AppState } from '~/store/app.store';
import type {
  BoundaryGroupId, BoundaryTerritoryGroupId,
} from '~/store/boundaries/boundaryIdentifier.type';
import { activeBoundaryTerritoryGroupsSelector } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.selectors';
import type { BoundaryFiltersState } from '~/store/mapSettings/toolsState/boundary/mapSettingsToolsStateBoundary.state';
import { boundaryFiltersStateToBoundaryFilters } from '~/store/mapSettings/toolsState/boundaryTerritoryGroups/mapSettingsBTGToolsState.helpers';

export const activeDataLayersBTGIdPerBoundaryGroupToolsStateSelector = (state: AppState): Record<BoundaryGroupId, BoundaryTerritoryGroupId> => {
  return state.map.mapSettings.data.toolsState.dataLayers.activeBTGIdPerBoundaryGroup;
};

export const dataLayersFiltersStateSelector = (state: AppState): BoundaryFiltersState =>
  state.map.mapSettings.data.toolsState.dataLayers.filters;

export const dataLayersFiltersSelector = createStateSelector([
  dataLayersFiltersStateSelector,
  (state: AppState) => activeBoundaryTerritoryGroupsSelector(state, true),
], boundaryFiltersStateToBoundaryFilters);

export const useDataLayersFilters = () => useSelector(dataLayersFiltersSelector);
